import { Icon, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import PProgressBar from './PProgressBar'

const PActionButton = ({ title, status, onClick, sx, ...rest }) => {
  return (
    <>
      <Box
        sx={{
          cursor: 'pointer',
          bgcolor: 'white.main',
          boxShadow: 'none',
          border: 1,
          borderRadius: '4.5px',
          borderColor: 'gray-line.main',
          ...sx,
        }}
        onClick={onClick}
      >
        <Box display="flex" alignItems="center" justifyContent="space-between" py={2.5} px={3}>
          <Box>
            <Typography textTransform="capitalize" variant="h4" fontWeight="bold">
              {title}
            </Typography>
            <Box display="flex" alignItems="center" gap={1}>
              {status === 'Completed' ? (
                <Typography color="light-gray-text.main" variant="body1">
                  {status}
                </Typography>
              ) : (
                <Typography color="positive.main" variant="body1">
                  Active
                </Typography>
              )}
              <Icon sx={{ fontSize: 7, color: 'light-gray-text.main' }}>circle</Icon>
              <Typography color="light-gray-text.main" variant="body1">
                {rest.start_date} - {rest.end_date}
              </Typography>
            </Box>
          </Box>
          {status === 'Active' && (
            <Box
              sx={rest.progress === 100 ? null : { width: '50%' }}
              display="flex"
              alignItems="center"
            >
              {rest.progress === 100 ? (
                <Box display="flex" gap={1} alignItems="center">
                  <Icon sx={{ fontSize: 20, color: 'positive.main' }}>check_circle</Icon>
                  <Typography color="light-gray-text.main">Completed</Typography>
                </Box>
              ) : (
                <PProgressBar
                  progress={rest.progress}
                  width="100%"
                  completedSub={rest.completedSub}
                  totalSub={rest.totalSub}
                />
              )}
              {onClick && <Icon sx={{ color: 'alternate.main' }}>arrow_forward_ios</Icon>}
            </Box>
          )}
        </Box>
      </Box>
    </>
  )
}

export default PActionButton
